module.exports = __webpack_public_path__ + "img/audioring@2x.23412c4.png";